import Link from "next/link";
import { Tabs } from "ui";
import { useCarriedQueryParams } from "./utils";

export function ReportsNavigationTabs({
  activeTab,
}: {
  activeTab: "payment-performance" | "volume-revenue" | "declines" | "brands";
}) {
  const query = useCarriedQueryParams();

  return (
    <Tabs value={activeTab}>
      <Tabs.List>
        <Tabs.Tab
          value="payment-performance"
          nativeButton={false}
          render={
            <Link href={{ pathname: "/reports/payment-performance", query }} />
          }
        >
          Payment performance
        </Tabs.Tab>
        <Tabs.Tab
          value="volume-revenue"
          nativeButton={false}
          render={
            <Link href={{ pathname: "/reports/volume-revenue", query }} />
          }
        >
          Volume & Revenue
        </Tabs.Tab>
        <Tabs.Tab
          value="declines"
          nativeButton={false}
          render={<Link href={{ pathname: "/reports/declines", query }} />}
        >
          Declines
        </Tabs.Tab>
        <Tabs.Tab
          value="brands"
          nativeButton={false}
          render={<Link href={{ pathname: "/reports/brands", query }} />}
        >
          Brands
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
